import mitt, { Handler, type Emitter } from 'mitt'

export const enum MobileEmitterEvents {
  /** 登录成功 */
  MOBILE_LOGIN_SUCCESS = 'MOBILE_LOGIN_SUCCESS',
}

export const enum PcEmitterEvents {
  /** 登录成功 */
  PC_LOGIN_SUCCESS = 'PC_LOGIN_SUCCESS',
}

type Events = {
  [MobileEmitterEvents.MOBILE_LOGIN_SUCCESS]: void
  [PcEmitterEvents.PC_LOGIN_SUCCESS]: void
}

type MittWithOnce = Emitter<Events> & {
  once<Key extends keyof Events>(type: Key, handler: Handler<Events[Key]>): void
}

const emitter: MittWithOnce = mitt<Events>() as MittWithOnce

emitter.once = <Key extends keyof Events>(type: Key, handler: Handler<Events[Key]>) => {
  const wrapper: Handler<Events[Key]> = (...event) => {
    handler(...event)
    emitter.off(type, wrapper)
  }
  emitter.on(type, wrapper)
}

export default emitter
